"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOtherIncomeRequest = exports.transformOtherIncomeListResponse = exports.transformOtherIncomeResponse = void 0;
const Error_1 = require("./Error");
const Money_1 = require("./Money");
const Tax_1 = require("./Tax");
const Date_1 = require("./Date");
var CategoryName;
(function (CategoryName) {
    CategoryName["advertising"] = "advertising";
    CategoryName["in_person_sales"] = "in_person_sales";
    CategoryName["online_sales"] = "online_sales";
    CategoryName["rentals"] = "rentals";
    CategoryName["other"] = "other";
})(CategoryName || (CategoryName = {}));
var VisState;
(function (VisState) {
    VisState[VisState["active"] = 0] = "active";
    VisState[VisState["deleted"] = 1] = "deleted";
    VisState[VisState["archived"] = 2] = "archived";
})(VisState || (VisState = {}));
function transformOtherIncomeResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { other_income } = response.response.result;
    return transformOtherIncomeParsedResponse(other_income);
}
exports.transformOtherIncomeResponse = transformOtherIncomeResponse;
function transformOtherIncomeListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { other_income, per_page, total, page, pages } = response.response.result;
    return {
        otherIncomes: other_income.map((income) => transformOtherIncomeParsedResponse(income)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformOtherIncomeListResponse = transformOtherIncomeListResponse;
function transformOtherIncomeParsedResponse(income) {
    return {
        incomeId: income.incomeid,
        amount: income.amount && (0, Money_1.transformMoneyParsedResponse)(income.amount),
        categoryName: income.category_name,
        createdAt: income.created_at && (0, Date_1.transformDateResponse)(income.created_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        date: income.date && (0, Date_1.transformDateResponse)(income.date, Date_1.DateFormat['YYYY-MM-DD']),
        note: income.note,
        paymentType: income.payment_type,
        source: income.source,
        taxes: income.taxes && income.taxes.map((tax) => (0, Tax_1.transformTaxParsedResponse)(tax)),
        updatedAt: income.updated_at && (0, Date_1.transformDateResponse)(income.updated_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        visState: income.vis_state,
    };
}
function transformOtherIncomeRequest(income) {
    return JSON.stringify({
        other_income: {
            amount: income.amount,
            category_name: income.categoryName,
            date: income.date && (0, Date_1.transformDateRequest)(income.date),
            note: income.note,
            payment_type: income.paymentType,
            source: income.source,
            taxes: income.taxes && income.taxes.map((tax) => (0, Tax_1.transformTaxParsedRequest)(tax)),
        },
    });
}
exports.transformOtherIncomeRequest = transformOtherIncomeRequest;
//# sourceMappingURL=OtherIncome.js.map